"use strict";

exports.__esModule = true;
exports.DataHooks = void 0;
var DataHooks = {
  title: 'title',
  subtitle: 'subtitle',
  suffix: 'suffix'
};
exports.DataHooks = DataHooks;
//# sourceMappingURL=hooks.js.map